import {
  UpdatePasswordForm,
  UpdateWhatsappNumberForm,
} from '../../components/forms/Forms';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import secureLocalStorage from 'react-secure-storage';
import { config } from '../../Constants';
import toast from 'react-hot-toast';

const Settings = () => {
  const [whatsappData, setWhatsappData] = useState({});
  const [emailFrequency, setEmailFrequency] = useState('weekly');
  const [savingFrequency, setSavingFrequency] = useState(false);
  const baseURL = config.baseURL;

  const { token } = JSON.parse(secureLocalStorage.getItem(`user-info`));

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [whatsappRes, settingsRes] = await Promise.all([
          axios.get(`${baseURL}/whatsapp`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
          axios.get(`${baseURL}/system-settings/profit-email-frequency`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
        ]);
        setWhatsappData(whatsappRes.data[0]);
        setEmailFrequency(settingsRes.data.frequency || 'weekly');
      } catch (error) {
        console.error('Error fetching settings:', error);
      }
    };
    fetchData();
    // eslint-disable-next-line
  }, []);

  const handleFrequencyChange = async (newFrequency) => {
    setSavingFrequency(true);
    try {
      await axios.patch(
        `${baseURL}/system-settings/profit-email-frequency`,
        { frequency: newFrequency },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setEmailFrequency(newFrequency);
      toast.success(`Profit email frequency updated to ${newFrequency}`);
    } catch (error) {
      toast.error('Failed to update email frequency');
    } finally {
      setSavingFrequency(false);
    }
  };

  return (
    <main className='content settings-page'>
      <h1 className='title'>Settings</h1>

      <div className='block'>
        <div className='title-block'>
          <h2 className='title'>Password</h2>
          <h4 className='sub-title'>Update Password</h4>
        </div>
        <hr />
        <UpdatePasswordForm />
      </div>

      <div className='block'>
        <div className='title-block'>
          <h2 className='title'>WhatsApp Number</h2>
          <h4 className='sub-title'>Update WhatsApp number</h4>
        </div>
        <hr />
        <UpdateWhatsappNumberForm data={whatsappData} />
      </div>

      <div className='block'>
        <div className='title-block'>
          <h2 className='title'>Profit Email Notifications</h2>
          <h4 className='sub-title'>Configure how often users receive profit update emails</h4>
        </div>
        <hr />
        <div className='email-frequency-setting'>
          <div className='frequency-options'>
            <label className={`frequency-option ${emailFrequency === 'weekly' ? 'active' : ''}`}>
              <input
                type='radio'
                name='emailFrequency'
                value='weekly'
                checked={emailFrequency === 'weekly'}
                onChange={() => handleFrequencyChange('weekly')}
                disabled={savingFrequency}
              />
              <div className='option-content'>
                <span className='option-title'>Weekly</span>
                <span className='option-desc'>Send profit summary every Monday</span>
              </div>
            </label>
            <label className={`frequency-option ${emailFrequency === 'daily' ? 'active' : ''}`}>
              <input
                type='radio'
                name='emailFrequency'
                value='daily'
                checked={emailFrequency === 'daily'}
                onChange={() => handleFrequencyChange('daily')}
                disabled={savingFrequency}
              />
              <div className='option-content'>
                <span className='option-title'>Daily</span>
                <span className='option-desc'>Send profit update every day</span>
              </div>
            </label>
          </div>
          {savingFrequency && <p className='saving-text'>Saving...</p>}
        </div>
      </div>
    </main>
  );
};

export default Settings;
